enum FilterTypes {
  TradeFilter = "tradeFilter",
  receiptFilter = "receiptFilter",
  invoiceFilter = "invoiceFilter",
  packagingFilter = "packagingFilter",
  advancePayableFilter = "advancePayableFilter",
  netPayableFilter = "netPayableFilter",
  plantReceivableFilter = "plantReceivableFilter",
  invoiceReceivableFilter = "invoiceReceivableFilter",
  stockFilter = "stockFilter",
  offerFilter = "offerFilter",
  demandFilter = "demandFilter",
  storageFilter = "storageFilter",
  productionFilter = "productionFilter",
  productionFinalFilter = "productionFinalFilter",
}

export default FilterTypes
